<template>
  <div class="companies">
    <SectionHeader>
      <template v-slot:breadcrumbs>
        <BreadCrumbs
          :items="[
            { text: $t('meta.containers'), name: 'company_containers' },
            {
              text: container.name,
              name: 'company_container',
              params: { container_uuid: $route.params.container_uuid },
            },
            { text: $t('containers.addSensor') },
          ]"
        />
      </template>
    </SectionHeader>

    <div class="body-content cf">
      <CompanyNav />
      <Form @submit="addSensor" :title="$t('containers.addSensor')" style="padding: 0">
        <FormSelect
          :name="$t('meta.sensor')"
          @input="sensorUuid = $event"
          :value="sensorUuid"
          required
          :options="sensorOptions"
          :loading="loading"
          :pagination="{
            enabled: true,
            searchCallback: fetchSensorOptions,
          }"
          data-testid="form__sensor-select"
        />
        <p style="margin-bottom: 0">
          <input type="submit" :value="$t('meta.save')" class="button button-green button-100" />
        </p>
      </Form>
    </div>
  </div>
</template>

<script>
import BreadCrumbs from '@/components/BreadCrumbs/index.vue'
import FormSelect from '@/components/Form/Select/index.vue'
import Form from '@/components/Form/index.vue'
import SectionHeader from '@/components/SectionHeader'
import CompanyNav from '@/components/company_nav'

import containersApi from '@/api/container'
import sensorsApi from '@/api/sensors'

export default {
  name: 'company_container_type',
  inject: ['companyUser'],
  data() {
    return {
      loading: true,
      container: {},
      sensorOptions: [],
      sensorUuid: '',
      pagination: {
        searchQuery: null,
      },
    }
  },
  components: {
    BreadCrumbs,
    CompanyNav,
    Form,
    FormSelect,
    SectionHeader,
  },
  methods: {
    async addSensor() {
      const success = await containersApi.sensors.assign(this.container.uuid, this.sensorUuid)
      if (success) {
        await this.$router.push(`/company/containers/${this.$route.params.container_uuid}`)
      }
    },
    async fetchSensorOptions(query = null) {
      const params = { company_uuid: this.companyUser.company_uuid }
      if (query) params.search_phrase = query
      const paginatedOptions = await sensorsApi.selectableSensors(params)

      this.sensorOptions = paginatedOptions.sensors
    },
  },
  async created() {
    this.container = await containersApi.get(this.$route.params.container_uuid)

    await this.fetchSensorOptions()

    this.loading = false
  },
}
</script>
